import { IFilter } from "./interfaces";

export const archiveFilter: IFilter = {
  label: 'Archived',
  key: 'archived',
  type: 'boolean',
};

export const tagFilter: IFilter = {
  label: 'Tags',
  key: 'tags',
  type: 'tag',
};
